
define('tpl!ui/resource/tpl/list', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div class=\"resource-list\">\n    <ul></ul>\n    <div class=\"more hidden\">\n        <a href=\"#\" class=\"btn-info small\"><span class=\"icon-download\"></span> "
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Load more", options) : helperMissing.call(depth0, "__", "Load more", options)))
    + "</a>\n    </div>\n</div>\n\n";
  return buffer;
  });
});

